export default __webpack_public_path__ + "static/media/campaign-logo.b7d8cfb8.svg";